import { render, staticRenderFns } from "./ReturA5Delivery.vue?vue&type=template&id=11ce825e&scoped=true"
import script from "./ReturA5Delivery.vue?vue&type=script&lang=js"
export * from "./ReturA5Delivery.vue?vue&type=script&lang=js"
import style0 from "./ReturA5Delivery.vue?vue&type=style&index=0&id=11ce825e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ce825e",
  null
  
)

export default component.exports